import pc from './pc';
import m from './m';
import harmony from './harmony';
import ganji from './ganji';
import wuba from './wuba';
import zcm from './zcm';
import miniProgram from './miniProgram';

const platform: any = {
    pc,
    m,
    harmony,
    ganji,
    wuba,
    wbutown: wuba,
    zcm,
    miniProgram
};

export default platform;
